import type { AcpSessionAgentKey } from '../acp-agent.js';
import { createEmptyAcpClientState } from '../ensure-acp-client.js';
import type { AcpManagerContext } from './acp-manager-context.js';

export function getAcpSessionAgentState(ctx: AcpManagerContext, acpSessionAgentKey: AcpSessionAgentKey) {
  let state = ctx.acpAgents.get(acpSessionAgentKey);
  if (!state) {
    state = createEmptyAcpClientState();
    ctx.acpAgents.set(acpSessionAgentKey, state);
  }
  return state;
}
